const localStorage = {
  SLIDER_SCREEN: 'SLIDER_SCREEN',
  ONBOARDING_SKIPPED: 'ONBOARDING_SKIPPED',
};
export default localStorage;